import { Button } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 0 20px 20px;

  .ant-form-item-label {
    font-size: 14px;
    font-weight: 700;
    line-height: 19px;
  }

  .ant-input-prefix {
    margin-right: 0;
  }

  .ant-select {
    cursor: default;
  }

  .ant-select-selector {
    cursor: pointer;
  }
`;

export const ScrollableContainer = styled.div`
  padding-top: 8px;
  max-height: calc(100vh - 370px);
  overflow-y: auto;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
`;

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #EDEDED;
  border-radius: 4px;
  margin-bottom: 24px;
  position: relative;

  .ant-form-item {
    margin-bottom: 0;
    padding-top: 10px;
  }

  .ant-form-item:first-child {
    padding-bottom: 1px;
  }

  .ant-form-item:last-child {
    border-top: 1px solid #EDEDED;
  }

  .ant-form-item-label {
    padding: 0;
    padding-left: 12px;
  }

  .ant-form-item-label > label {
    font-size: 13px;
    line-height: 18px;
    font-weight: 400;
    color: #858585 !important;
  }

  .ant-select-selector {
    border: none !important;
  }

  .ant-select-selection-item {
    color: #333333 !important;
    font-weight: 700;
  }

  .ant-form-item .ant-select {
    display: flex;
    align-items: center;
  }

  .ant-select .ant-select-selector {
    width: unset !important;
  }

  .ant-select-arrow {
    position: relative;
    margin-left: -10px;
  }
`;

export const ButtonWrapper = styled.div`
  padding-top: 24px;
`;

export const NextButton = styled(Button)`
  width: 100%;
  height: 44px;
  border-radius: 4px;
  font-family: ProximaNovaRg;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
  cursor: pointer;
`;

export const SwitchButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  color: #333333;
  background: #ffffff;
  font-size: 14px;
  line-height: 19px;
  border: 1px solid #EDEDED;
  border-radius: 50px;
  width: 28px;
  height: 28px;

  position: absolute;
  right: 16px;
  top: 47px;
  z-index: 1;

  img {
    cursor: pointer;
  }
`;

export const SectionTitle = styled.div`
  margin-bottom: 8px;

  h1, p {
    margin: 0;
    font-size: 13px;
    line-height: 18px;
  }

  h1 {
    font-weight: 700;
    color: #333333;
  }

  p {
    color: #858585;
  }
`;

export const StockListContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 180px;

  .ant-skeleton-input {
    border-radius: 4px;
  }
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 20px 0;
  gap: 20px;
`;

export const EmptyText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: center;

  h1, p {
    margin: 0;
  }

  h1 {
    font-size: 14px;
    line-height: 19px;
    font-weight: 700;
    color: #333333;
  }

  p {
    font-size: 13px;
    line-height: 18px;
    color: #858585;
  }
`;

export const StockItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #EDEDED;
  gap: 8px;

  &:last-child {
    border-bottom: none;
  }
`;

export const StockItemInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  gap: 8px;
`;

export const StockItemInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  h1, p {
    margin: 0;
  }

  h1 {
    font-size: 14px;
    line-height: 19px;
    font-weight: 700;
    color: #333333;
  }

  p {
    font-size: 13px;
    line-height: 18px;
    color: #858585;

    span {
      color: #333333;
    }
  }

  .ant-skeleton {
    height: 13px;
  }
`;

export const StockItemInputWrapper = styled.div`
  display: flex;
  min-width: 140px;
  flex: 0;

  .input-stepper-container {
    border: 1px solid #ededed;
    border-radius: 4px;

    &.active {
      border: 1px solid #00AB6B;
    }

    input {
      border: none;
    }

    button {
      background: #ffffff;
      border: none;

      :hover {
        background: #ededed;
      }
    }
  }
`;
